import script from "./TicketSolutionCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketSolutionCell.vue?vue&type=script&setup=true&lang=js"

import "./TicketSolutionCell.vue?vue&type=style&index=0&id=19c114eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c114eb"]])

export default __exports__